// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-2DRNc";
var _4 = "title-2juu_";
var _5 = "description-v6CKU";
var _6 = "icon_wrapper--yHoF";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "title", _5 as "description", _6 as "icon_wrapper" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "title": _4, "description": _5, "icon_wrapper": _6 }
